'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseReportController = function () {
  function BaseReportController(reportingService, loadingService, utilsService) {
    (0, _classCallCheck3.default)(this, BaseReportController);

    this.reportingService = reportingService;
    this.loadingService = loadingService;
    this.utilsService = utilsService;
  }

  (0, _createClass3.default)(BaseReportController, [{
    key: 'updateDateRange',
    value: function updateDateRange() {
      var _this = this;

      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');
      var src = this.reportingService.getDateRange(this.reportCriteria.dateRangeOption.id);

      src.then(function (response) {
        _this.reportCriteria.startDate = response.data.startDate ? new Date(response.data.startDate) : null;
        _this.reportCriteria.endDate = response.data.endDate ? new Date(response.data.endDate) : null;
      }).finally(function () {
        _this.loadingService.hideLoading('reportCriteria');
      });

      return src;
    }
  }, {
    key: 'parseStartAndEndDate',
    value: function parseStartAndEndDate(parsedCriteria) {
      if (this.reportCriteria.startDate) {
        parsedCriteria.startDate = this.reportCriteria.startDate.toUniversalFormat();
      }

      if (this.reportCriteria.endDate) {
        parsedCriteria.endDate = this.reportCriteria.endDate.toUniversalFormat();
      }
    }
  }, {
    key: 'getUserLocations',
    value: function getUserLocations() {
      var _this2 = this;

      var locationsWithRoles = this.authService.authData.userLocations.map(function (l) {
        return {
          id: l.key,
          name: l.value,
          roleId: (0, _lodash.find)(_this2.authService.authData.userRoles, function (o) {
            return o.entityId === l.key;
          }).roleId,
          isDefault: l.defaultLocation
        };
      });

      this.userLocations = (0, _lodash2.default)(locationsWithRoles).filter(function (o) {
        return o.roleId !== 2 || o.isDefault;
      }).map(function (o) {
        return { id: o.id, name: o.name };
      }).value();

      this.userLocations.unshift({ id: null, name: 'All' });
    }
  }]);
  return BaseReportController;
}();

exports.default = BaseReportController;


// WEBPACK FOOTER //
// ./client/app/components/reports/baseReportController.js